module.exports = {"id":"209769","name":"Bilal Başaçıkoğlu","rating":"71","photo":"./data/images/photos/2/209769.png","club":{"name":"Feyenoord","logo":"./data/images/clubs/Feyenoord.png"},"positions":["AD","AG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BilalBasacıkoglu0.json
// module id = 600
// module chunks = 0